import {createSelector} from 'reselect';
import moment from 'moment';

function prepareTaskTypes(state) {
    if (state.taskTypes) return state.taskTypes.map((task) => ({text: task.name, value: task.id}));
}

function prepareTask(state, ownProps) {
    if(!ownProps) return false;
    let tasks = null;
    if (ownProps.params.taskId) tasks = state.tasks.filter((task) => {
        return task.id == ownProps.params.taskId
    });
    if(tasks) return tasks[0];
    return null;
}

const getAllPropsSelector = (state, ownProps) => {
    return {
        timeSheets: state.timeSheets,
        projects: state.projectContainer.projects,
        tasks: state.tasks,
        taskTypes: prepareTaskTypes(state),
        task: prepareTask(state, ownProps)
    };
};

export default getAllPropsSelector;

export {
    getAllPropsSelector
};


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/selectors.js
 **/